import Render from '@Views/root/accounting/remittances/context-remittances.html'
import { Component, Vue } from 'vue-property-decorator'

@Render
@Component({})
export class ContextRemittances extends Vue {}